import EdCallsComponent from './ed-calls/ed-calls.component.vue';
import EdCallsInfoComponent from './ed-calls-info/ed-calls-info.component.vue';

export const CallsComponents = {
  EdCallsComponent,
  EdCallsInfoComponent,
}
